module.exports = __webpack_public_path__ + "static/media/paints_asian.d3fe3090.jfif";